// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e588b838","667":"85760aa1","900":"59375ef1","977":"23606eef","995":"195b8c82"}[chunkId] + ".chunk.js";
};